export default "__VITE_ASSET__Ddf$nH2J__"